import useApiCall from "@hooks/Shared/useApiCall";
import { IProject } from "@interfaces/Projects/Project";

const useGetProject = (projectId: string) =>
  useApiCall<IProject>({
    url: `/projects/${projectId}`,
  });

export default useGetProject;
